import { Col, Row, Typography } from "antd"
import { FunctionComponent } from "react"
import { InputNumberFormItem } from "../common/InputNumberFormItem";

const { Text } = Typography;

export type InputTarifProperties = {
    nameMontantBase: string;
    nameMontantEnfant: string;
    labelNbEnfant: string;
    readOnly: boolean;
}

export const InputTarif: FunctionComponent<InputTarifProperties> = ({ nameMontantBase, nameMontantEnfant, labelNbEnfant, readOnly }) => {
    return (
        <Row gutter={[16, 8]} style={{ marginBottom: '12px' }} align="middle">
            <Col xs={24} sm={24} md={3} style={{ display: 'flex', alignItems: 'center', paddingTop: '4px' }}>
                <Text strong style={{ fontSize: '13px', color: '#434343', whiteSpace: 'nowrap' }}>
                    {labelNbEnfant}
                </Text>
            </Col>
            <Col xs={24} sm={12} md={6}>
                <InputNumberFormItem
                    name={nameMontantBase}
                    label="Base"
                    addonAfter="€"
                    disabled={readOnly}
                    rules={[{ required: true, message: "Veuillez saisir un montant" }]}
                />
            </Col>
            <Col xs={24} sm={12} md={6}>
                <InputNumberFormItem
                    name={nameMontantEnfant}
                    label="Par enfant"
                    addonAfter="€"
                    disabled={readOnly}
                    rules={[{ required: true, message: "Veuillez saisir un montant" }]}
                />
            </Col>
        </Row>
    );

}
